"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("app");
var React = require("react");
var FilterableList_1 = require("Views/Partials/Components/FilterableList");
var FilterableListContainer_1 = require("Views/Partials/Components/FilterableList/FilterableListContainer");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var index_1 = require("../index");
var CaseStudiesDataService_1 = require("./CaseStudiesDataService");
var dictionary_1 = require("./dictionary");
var element = document.getElementById('case-studies-list-react');
document.querySelector('.main-content').classList.add('main-content-dynamic');
var dictionary = app_1.transformDictionary(dictionary_1.caseStudiesListDictionary, app_1.AttrService.data(element, 'dictionary'));
index_1.PageContext.initContext(FilterTypings_1.FilterableListTypeEnum.CaseStudies, element, dictionary);
var serviceConfig = FilterableList_1.createFilterableDataServiceConfig(FilterTypings_1.FilterableListTypeEnum.CaseStudies, element, dictionary);
var dataService = FilterableList_1.createFilterableDataService(CaseStudiesDataService_1.CaseStudiesDataService, serviceConfig);
app_1.reactDOMRender(React.createElement(FilterableListContainer_1.FilterableListContainer, { service: dataService }), element);
